import PageLayout from "../UI/PageLayout";
import { Card, Row, Col, Typography, Tooltip, Skeleton } from "antd";
import PropTypes from "prop-types";

const { Title, Text } = Typography;

const SettingsLandingPage = ({ settingsCategories, onCardClick, loading }) => {
    const renderSkeletonCards = () => {
        return Array(6).fill(null).map((_, index) => (
            <Col xs={24} sm={12} md={8} key={`skeleton-${index}`}>
                <Card style={{ 
                    height: '100%',
                    borderTop: '3px solid #f0f0f0'
                }}>
                    <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center',
                        textAlign: 'center',
                        gap: '16px'
                    }}>
                        <div style={{ 
                            padding: '12px',
                            borderRadius: '50%',
                            backgroundColor: '#f0f0f0'
                        }}>
                            <Skeleton.Avatar active size={32} shape="circle" />
                        </div>
                        <Skeleton.Input active size="small" style={{ width: 150 }} />
                        <Skeleton.Input active size="small" style={{ width: 250 }} />
                    </div>
                </Card>
            </Col>
        ));
    };

    return (
        <PageLayout
            title="Settings"
            subTitle="Customize your experience"
            content={
                <div style={{
                    padding: '24px',
                    maxWidth: '1200px',
                    margin: '0 auto'
                }}>
                    <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                        <Title level={2}>Customize Your Experience</Title>
                        <Text style={{ fontSize: '16px', color: '#666' }}>
                            Manage your preferences, update your account, and fine-tune how things work—so everything feels just right.
                        </Text>
                    </div>

                    <Row gutter={[24, 24]}>
                        {loading ? renderSkeletonCards() : settingsCategories.map((category, index) => (
                            <Col xs={24} sm={12} md={8} key={index}>
                                {category.disabled ? (
                                    <Tooltip title="You do not have access to this setting.">
                                        <div
                                            style={{
                                                opacity: 0.5,
                                                filter: 'grayscale(0.5)',
                                                cursor: 'not-allowed',
                                                height: '100%',
                                            }}
                                        >
                                            <Card
                                                hoverable={false}
                                                onClick={() => {}}
                                                style={{
                                                    height: '100%',
                                                    borderTop: `3px solid ${category.color}`,
                                                }}
                                            >
                                                <div style={{ 
                                                    display: 'flex', 
                                                    flexDirection: 'column', 
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                    gap: '16px'
                                                }}>
                                                    <div style={{ 
                                                        color: category.color,
                                                        padding: '12px',
                                                        borderRadius: '50%',
                                                        backgroundColor: `${category.color}10`
                                                    }}>
                                                        {category.icon}
                                                    </div>
                                                    <Title level={4} style={{ margin: 0 }}>{category.title}</Title>
                                                    <Text>{category.description}</Text>
                                                </div>
                                            </Card>
                                        </div>
                                    </Tooltip>
                                ) : (
                                    <div
                                        style={{
                                            opacity: 1,
                                            cursor: 'pointer',
                                            height: '100%',
                                        }}
                                    >
                                        <Card
                                            hoverable
                                            onClick={() => onCardClick(category.path)}
                                            style={{
                                                height: '100%',
                                                borderTop: `3px solid ${category.color}`,
                                            }}
                                        >
                                            <div style={{ 
                                                display: 'flex', 
                                                flexDirection: 'column', 
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                gap: '16px'
                                            }}>
                                                <div style={{ 
                                                    color: category.color,
                                                    padding: '12px',
                                                    borderRadius: '50%',
                                                    backgroundColor: `${category.color}10`
                                                }}>
                                                    {category.icon}
                                                </div>
                                                <Title level={4} style={{ margin: 0 }}>{category.title}</Title>
                                                <Text>{category.description}</Text>
                                            </div>
                                        </Card>
                                    </div>
                                )}
                            </Col>
                        ))}
                    </Row>
                </div>
            }
        />
    );
};

SettingsLandingPage.propTypes = {
  settingsCategories: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      icon: PropTypes.node.isRequired,
      path: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  onCardClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default SettingsLandingPage;
